export const MAX_REPLY_SHORTCUT = 50;
